/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--mobile-flyout[_ngcontent-%COMP%]{position:fixed;box-sizing:border-box;z-index:100;width:100%;height:100%;right:0;left:0;bottom:0;top:56px;padding:2rem 1rem 0;background-color:#fff}"];
export { styles as styles };
